// Generated by purs version 0.15.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as PartyCarlo_Capability_Now from "../PartyCarlo.Capability.Now/index.js";
import * as PartyCarlo_Data_Display from "../PartyCarlo.Data.Display/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "level";
    }
});
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "ts";
    }
});
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "vals";
    }
});
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidString);
var display = /* #__PURE__ */ PartyCarlo_Data_Display.display(PartyCarlo_Data_Display.displayDateTime);
var $$Error = /* #__PURE__ */ (function () {
    function $$Error() {

    };
    $$Error.value = new $$Error();
    return $$Error;
})();
var Warn = /* #__PURE__ */ (function () {
    function Warn() {

    };
    Warn.value = new Warn();
    return Warn;
})();
var Info = /* #__PURE__ */ (function () {
    function Info() {

    };
    Info.value = new Info();
    return Info;
})();
var Debug = /* #__PURE__ */ (function () {
    function Debug() {

    };
    Debug.value = new Debug();
    return Debug;
})();
var Log = /* #__PURE__ */ (function () {
    function Log(value0) {
        this.value0 = value0;
    };
    Log.create = function (value0) {
        return new Log(value0);
    };
    return Log;
})();
var vals = function (v) {
    return v.value0.vals;
};
var ts = function (v) {
    return v.value0.ts;
};
var msg = function (dictDisplay) {
    var display2 = PartyCarlo_Data_Display.display(dictDisplay);
    return function (v) {
        return display2(v.value0.vals);
    };
};
var mkLog = function (dictNow) {
    var Monad0 = dictNow.Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var nowDateTime = PartyCarlo_Capability_Now.nowDateTime(dictNow);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (l) {
        return function (x) {
            return bind(nowDateTime)(function (now) {
                return pure(new Log({
                    ts: now,
                    level: l,
                    vals: x
                }));
            });
        };
    };
};
var level = function (v) {
    return v.value0.level;
};
var genericLogLevel = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return $$Error.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Warn.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Info.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return Debug.value;
        };
        throw new Error("Failed pattern match at PartyCarlo.Data.Log (line 29, column 1 - line 29, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof $$Error) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Warn) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Info) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Debug) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at PartyCarlo.Data.Log (line 29, column 1 - line 29, column 54): " + [ x.constructor.name ]);
    }
};
var showLogLevel = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericLogLevel)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Error";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Warn";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Info";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Debug";
        }
    })))))
};
var showLog = function (dictShow) {
    var show = Data_Show.show(showRecord(showRecordFieldsCons(showRecordFieldsCons1(showRecordFieldsConsNil(dictShow))(Data_DateTime.showDateTime))(showLogLevel)));
    return {
        show: function (v) {
            return "(Log " + (show(v.value0) + ")");
        }
    };
};
var eqLogLevel = {
    eq: function (x) {
        return function (y) {
            if (x instanceof $$Error && y instanceof $$Error) {
                return true;
            };
            if (x instanceof Warn && y instanceof Warn) {
                return true;
            };
            if (x instanceof Info && y instanceof Info) {
                return true;
            };
            if (x instanceof Debug && y instanceof Debug) {
                return true;
            };
            return false;
        };
    }
};
var displayLogLevel = {
    display: function (v) {
        if (v instanceof $$Error) {
            return "ERROR";
        };
        if (v instanceof Warn) {
            return "WARN ";
        };
        if (v instanceof Info) {
            return "INFO ";
        };
        if (v instanceof Debug) {
            return "DEBUG";
        };
        throw new Error("Failed pattern match at PartyCarlo.Data.Log (line 34, column 1 - line 38, column 28): " + [ v.constructor.name ]);
    }
};
var display1 = /* #__PURE__ */ PartyCarlo_Data_Display.display(displayLogLevel);
var humanString = function (dictDisplay) {
    var msg1 = msg(dictDisplay);
    return function (v) {
        return fold([ display(v.value0.ts), " ", display1(v.value0.level), " ", msg1(v) ]);
    };
};
export {
    $$Error as Error,
    Warn,
    Info,
    Debug,
    humanString,
    level,
    mkLog,
    msg,
    ts,
    vals,
    eqLogLevel,
    genericLogLevel,
    showLogLevel,
    displayLogLevel,
    showLog
};
